<template>
    <section class="search-element-outer">
        <a
            :href="result.detailPage"
            class="search-element"
        >
            <div class="search-element__image">
                <img
                    v-if="result.picture.src"
                    :src="result.picture.src"
                    :alt="result.picture.alt"
                >
            </div>
            <div class="search-element__description">
                <div class="search-element__text">
                    <div
                        class="search-element__name"
                    >
                        {{ result.name }}
                    </div>
                </div>
            </div>
        </a>

    </section>
</template>

<script>
export default {
    name: 'SearchElement',
    props: ['result'],
}
</script>

<style lang="scss" scoped>
.search-element {
    display: grid;
    grid-template-columns: 80px 1fr;
    grid-column-gap: 8px;
    align-items: center;
    background-color: #fff;
    padding-right: 4px;
    border-radius: 6px;
    overflow: hidden;

    &:hover {
        box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.05), 0px 0px 40px rgba(0, 0, 0, 0.1);
    }

    &__image {
        width: 80px;
        height: 80px;

        img {
            max-width: 100%;
            max-height: 100%;
        }
    }

    &__description {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-grow: 1;
        padding: 15px 0;
    }

    &__name {
        font-weight: 600;
        font-size: rem(14);
        letter-spacing: 0.06em;
        text-transform: uppercase;
        margin-bottom: 8px;

    }

    &__prices {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        flex-shrink: 0;
        margin-left: 20px;
    }

    &__text {
        display: flex;
        flex-direction: column;
    }

    :deep(.def-price-old) {
        font-weight: 600;
        font-size: rem(9);
        text-decoration-line: line-through;
        color: #5F5F67;
        margin-bottom: 4px;
    }

    :deep(.def-sale) {
        margin-top: 8px;
    }

    :deep(.def-collection) {
        margin-top: 8px;

    }
}
</style>